import { FC, SyntheticEvent } from 'react';
import triggerTracking from '@blueprint/tracking';
import { BuyRentTabsWrapper, BuyRentTab } from './BuyRentTabs.styles';

enum SearchType {
    ForSale = 'for-sale',
    ToRent = 'to-rent',
    NewHomes = 'new-homes'
}
type SearchPageType = SearchType | 'for-sale' | 'to-rent' | 'new-homes';

type Tab = SearchPageType | 'house-prices';

export type Props = {
    onPress: (tab: Tab) => void;
    selected: Tab;
    includeHousePrices: boolean;
    testIdSuffix: 'desktop-homepage' | 'mobile' | 'mobile-modal';
};

const buyTabText = 'For sale';
const rentTabText = 'To rent';
const housePricesTabText = 'House prices';

export const BuyRentTabs: FC<React.PropsWithChildren<Props>> = ({
    onPress,
    selected,
    testIdSuffix,
    includeHousePrices
}) => {
    const handlePress = (eventLabel: Tab) => {
        triggerTracking({
            event: 'GAEvent',
            eventCategory: 'homepage',
            eventAction: 'channel_tab',
            eventLabel
        });

        onPress(eventLabel);
    };

    return (
        <BuyRentTabsWrapper role="tablist">
            <BuyRentTab
                href="/for-sale/"
                onClick={(event: SyntheticEvent) => {
                    event.preventDefault();
                    handlePress('for-sale');
                }}
                isSelected={selected === 'for-sale'}
                data-testid={`for-sale-tab-${testIdSuffix}`}
            >
                {buyTabText}
            </BuyRentTab>
            <BuyRentTab
                href="/to-rent/"
                onClick={(event: SyntheticEvent) => {
                    event.preventDefault();
                    handlePress('to-rent');
                }}
                isSelected={selected === 'to-rent'}
                data-testid={`to-rent-tab-${testIdSuffix}`}
            >
                {rentTabText}
            </BuyRentTab>
            {includeHousePrices ? (
                <BuyRentTab
                    href="/house-prices/"
                    role="tab"
                    onClick={(event: SyntheticEvent) => {
                        event.preventDefault();
                        handlePress('house-prices');
                    }}
                    isSelected={selected === 'house-prices'}
                    data-testid={`house-prices-tab-${testIdSuffix}`}
                >
                    {housePricesTabText}
                </BuyRentTab>
            ) : null}
        </BuyRentTabsWrapper>
    );
};
